import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserSuggestionsService {
  private apiService = inject(ApiService);

  deleteUserSuggestions(id: number) {
    return this.apiService.delete('suggestion', id);
  }

  getUserSuggestions(): Observable<any> {
    return this.apiService.getAll(`suggestion`);
  }

  toggleReadStatus(id: number): Observable<any> {
    return this.apiService.getById('suggestion/toggleReadStatus', id);
  }

  sendMailSuggestions(): Observable<any> {
    return this.apiService.store('dashboard/sendReportMail', {});
  }
}
